<template>
    <div class="card">
        <div class="card-header">
            <h4 class="card-title">
                {{$t("ultimosTickets")}}
            </h4>
            <p class="card-category">
                {{$t("ultimosMovimientosDeLaCajaPorOperario")}}
            </p>
            <div class="text-right">
                <router-link :to="{name:'online-tickets', params:{idBusiness:idBusiness}}" class="text-right">
                    <span class="verTodos"><i class="fa fa-eye"></i> {{$t("verTodos")}}</span>
                </router-link>
            </div>
        </div>
        <div class="card-body">
            <div class="row">
                <div class="col-md-12">
                    <template v-for="ticket in tickets.slice(0, 3)">
                        <ticket :ticket="ticket"></ticket>
                    </template>
                </div>
            </div>
        </div>
        <div class="card-footer">
            <hr>
            <div class="stats">
                <i class="fa fa-clock"></i> {{lastDate | timeago}}
            </div>
        </div>
    </div>
</template>
<script>

    import swal from 'sweetalert2'
    import Ticket from '../../../Widgets/Ticket.vue'

    export default {
        created() {
            this.getTickets();
          //  this.getConfigTpvBase();
        },
        props: ['onlineDetails', 'lastDate', 'idBusiness'],
        data() {
            return {
                tickets: [],
            }
        },
        components: {
            Ticket,
        },
        methods: {
            getTickets() {
                var tpvs = [];
                this.onlineDetails.forEach(function (x) {
                    if (x && x.online == 1) {
                        tpvs.push(x.idTpv);
                    }
                });

                var config = {
                    params: {
                        idBusiness: this.idBusiness,
                        listTpv: JSON.stringify(tpvs),
                        jwt: this.$store.getters.jwt
                    },
                    headers: {'Authorization': "Bearer " + this.$store.getters.jwt}
                };

                let vm = this;
                this.axios.get(this.$store.getters.apiUrl + "online/getTickets", config)
                    .then(function (response) {
                        if (response.data.response) {
                            vm.tickets = response.data.result.tickets;
                        } else {
                            swal({
                                title: vm.$t('atencion'),
                                text: response.data.message,
                                confirmButtonClass: 'btn btn-info btn-fill',
                                type: 'error'
                            });
                        }
                    })
                    .catch(function (error) {
                        console.log(error);
                    });
            },
        },
        watch: {
            onlineDetails: function (newOnlineDetails, oldOnlineDetails) {
                this.getTickets();
            }
        },
    }
</script>
<style scoped>
    .card-body {
        padding: 10px 15px;
    }

    .title {
        font-weight: bold;
    }

    tfoot tr td {
        font-size: 1.2em;
        color: #fff;
        text-shadow: 1px 1px #111;
        font-weight: bold;
    }

    .card-category {
        color: #9a9a9a
    }

    .verTodos {
        font-size: 0.9em
    }


</style>



// WEBPACK FOOTER //
// src/pages/Dashboard/Online/Widgets/Tickets.vue